import { useSelector } from 'react-redux';
import { getModuleDataByModuleName } from '../redux/selectors/modules';
import useGruser from './useGruser';
/** Returns the first Gruser module found with the given module name */ export default function useModuleDataByName(moduleName) {
    const { gruser } = useGruser();
    return useSelector((state)=>getModuleDataByModuleName(state, gruser, moduleName));
}

//# sourceMappingURL=useModuleDataByName.js.map